const Particles1 = ({ sx }) => {
  const _sx = sx ?? {};
  return (
    <svg
      style={_sx}
      width="259"
      height="231"
      viewBox="0 0 259 231"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <line
          x1="238.293"
          y1="13.0004"
          x2="172.714"
          y2="45.0859"
          stroke="white"
          strokeOpacity="0.84"
        />
        <line
          x1="4.67006"
          y1="-65.7598"
          x2="22.4696"
          y2="15.5001"
          stroke="white"
          strokeOpacity="0.84"
        />
        <line
          x1="22.4452"
          y1="15.421"
          x2="66.6133"
          y2="125.485"
          stroke="white"
          strokeOpacity="0.84"
        />
        <line
          x1="174.991"
          y1="44.5826"
          x2="169.977"
          y2="108.885"
          stroke="white"
          strokeOpacity="0.84"
        />
        <line
          x1="66.5656"
          y1="125.395"
          x2="105.318"
          y2="183.655"
          stroke="white"
          strokeOpacity="0.84"
        />
        <line
          x1="104.523"
          y1="183.606"
          x2="171.004"
          y2="106.429"
          stroke="white"
          strokeOpacity="0.84"
        />
        <line
          x1="169.66"
          y1="106.431"
          x2="256.407"
          y2="163.457"
          stroke="white"
          strokeOpacity="0.84"
        />
        <line
          x1="256.109"
          y1="163.375"
          x2="308.053"
          y2="160.956"
          stroke="white"
          strokeOpacity="0.84"
        />
        <line
          x1="344.213"
          y1="212.254"
          x2="253.75"
          y2="161.407"
          stroke="white"
          strokeOpacity="0.84"
        />
        <line
          x1="255.496"
          y1="160.937"
          x2="237.437"
          y2="9.61373"
          stroke="white"
          strokeOpacity="0.84"
        />
        <line
          x1="238.545"
          y1="12.7152"
          x2="222.658"
          y2="58.5038"
          stroke="white"
          strokeOpacity="0.84"
        />
        <line
          x1="222.524"
          y1="58.708"
          x2="169.724"
          y2="107.217"
          stroke="white"
          strokeOpacity="0.84"
        />
        <line
          x1="222.662"
          y1="58.1867"
          x2="256.608"
          y2="163.722"
          stroke="white"
          strokeOpacity="0.84"
        />
        <line
          x1="225.033"
          y1="58.6773"
          x2="172.205"
          y2="42.1169"
          stroke="white"
          strokeOpacity="0.84"
        />
        <line
          x1="174.395"
          y1="45.034"
          x2="19.7925"
          y2="14.1928"
          stroke="white"
          strokeOpacity="0.84"
        />
        <line
          x1="22.2416"
          y1="15.1803"
          x2="171.644"
          y2="106.329"
          stroke="white"
          strokeOpacity="0.84"
        />
        <line
          x1="169.465"
          y1="107.342"
          x2="64.1378"
          y2="124.26"
          stroke="white"
          strokeOpacity="0.84"
        />
        <circle
          cx="170.385"
          cy="106.802"
          r="4"
          transform="rotate(87.3336 170.385 106.802)"
          fill="white"
        />
        <circle
          cx="170.385"
          cy="106.802"
          r="4"
          transform="rotate(87.3336 170.385 106.802)"
          fill="white"
        />
        <circle
          cx="170.385"
          cy="106.802"
          r="4"
          transform="rotate(87.3336 170.385 106.802)"
          fill="white"
        />
        <circle
          cx="170.385"
          cy="106.802"
          r="4"
          transform="rotate(87.3336 170.385 106.802)"
          fill="white"
        />
        <circle
          cx="170.385"
          cy="106.802"
          r="4"
          transform="rotate(87.3336 170.385 106.802)"
          fill="white"
        />
        <circle
          cx="170.385"
          cy="106.802"
          r="3.5"
          transform="rotate(87.3336 170.385 106.802)"
          stroke="white"
          strokeOpacity="0.84"
        />
        <circle
          cx="104.855"
          cy="182.933"
          r="4"
          transform="rotate(87.3336 104.855 182.933)"
          fill="white"
        />
        <circle
          cx="104.855"
          cy="182.933"
          r="4"
          transform="rotate(87.3336 104.855 182.933)"
          fill="white"
        />
        <circle
          cx="104.855"
          cy="182.933"
          r="4"
          transform="rotate(87.3336 104.855 182.933)"
          fill="white"
        />
        <circle
          cx="104.855"
          cy="182.933"
          r="4"
          transform="rotate(87.3336 104.855 182.933)"
          fill="white"
        />
        <circle
          cx="104.855"
          cy="182.933"
          r="4"
          transform="rotate(87.3336 104.855 182.933)"
          fill="white"
        />
        <circle
          cx="104.855"
          cy="182.933"
          r="3.5"
          transform="rotate(87.3336 104.855 182.933)"
          stroke="white"
          strokeOpacity="0.84"
        />
        <circle
          cx="66.0564"
          cy="123.674"
          r="4"
          transform="rotate(87.3336 66.0564 123.674)"
          fill="white"
        />
        <circle
          cx="66.0564"
          cy="123.674"
          r="4"
          transform="rotate(87.3336 66.0564 123.674)"
          fill="white"
        />
        <circle
          cx="66.0564"
          cy="123.674"
          r="4"
          transform="rotate(87.3336 66.0564 123.674)"
          fill="white"
        />
        <circle
          cx="66.0564"
          cy="123.674"
          r="4"
          transform="rotate(87.3336 66.0564 123.674)"
          fill="white"
        />
        <circle
          cx="66.0564"
          cy="123.674"
          r="4"
          transform="rotate(87.3336 66.0564 123.674)"
          fill="white"
        />
        <circle
          cx="66.0564"
          cy="123.674"
          r="3.5"
          transform="rotate(87.3336 66.0564 123.674)"
          stroke="white"
          strokeOpacity="0.84"
        />
        <circle
          cx="21.9813"
          cy="15.6073"
          r="4"
          transform="rotate(87.3336 21.9813 15.6073)"
          fill="white"
        />
        <circle
          cx="21.9813"
          cy="15.6073"
          r="4"
          transform="rotate(87.3336 21.9813 15.6073)"
          fill="white"
        />
        <circle
          cx="21.9813"
          cy="15.6073"
          r="4"
          transform="rotate(87.3336 21.9813 15.6073)"
          fill="white"
        />
        <circle
          cx="21.9813"
          cy="15.6073"
          r="4"
          transform="rotate(87.3336 21.9813 15.6073)"
          fill="white"
        />
        <circle
          cx="21.9813"
          cy="15.6073"
          r="4"
          transform="rotate(87.3336 21.9813 15.6073)"
          fill="white"
        />
        <circle
          cx="21.9813"
          cy="15.6073"
          r="3.5"
          transform="rotate(87.3336 21.9813 15.6073)"
          stroke="white"
          strokeOpacity="0.84"
        />
        <circle
          cx="175.491"
          cy="44.4969"
          r="4"
          transform="rotate(87.3336 175.491 44.4969)"
          fill="white"
        />
        <circle
          cx="175.491"
          cy="44.4969"
          r="4"
          transform="rotate(87.3336 175.491 44.4969)"
          fill="white"
        />
        <circle
          cx="175.491"
          cy="44.4969"
          r="4"
          transform="rotate(87.3336 175.491 44.4969)"
          fill="white"
        />
        <circle
          cx="175.491"
          cy="44.4969"
          r="4"
          transform="rotate(87.3336 175.491 44.4969)"
          fill="white"
        />
        <circle
          cx="175.491"
          cy="44.4969"
          r="4"
          transform="rotate(87.3336 175.491 44.4969)"
          fill="white"
        />
        <circle
          cx="175.491"
          cy="44.4969"
          r="3.5"
          transform="rotate(87.3336 175.491 44.4969)"
          stroke="white"
          strokeOpacity="0.84"
        />
        <circle
          cx="224.137"
          cy="57.2479"
          r="4"
          transform="rotate(87.3336 224.137 57.2479)"
          fill="white"
        />
        <circle
          cx="224.137"
          cy="57.2479"
          r="4"
          transform="rotate(87.3336 224.137 57.2479)"
          fill="white"
        />
        <circle
          cx="224.137"
          cy="57.2479"
          r="4"
          transform="rotate(87.3336 224.137 57.2479)"
          fill="white"
        />
        <circle
          cx="224.137"
          cy="57.2479"
          r="4"
          transform="rotate(87.3336 224.137 57.2479)"
          fill="white"
        />
        <circle
          cx="224.137"
          cy="57.2479"
          r="4"
          transform="rotate(87.3336 224.137 57.2479)"
          fill="white"
        />
        <circle
          cx="224.137"
          cy="57.2479"
          r="3.5"
          transform="rotate(87.3336 224.137 57.2479)"
          stroke="white"
          strokeOpacity="0.84"
        />
        <circle
          cx="239.072"
          cy="12.5045"
          r="4"
          transform="rotate(87.3336 239.072 12.5045)"
          fill="white"
        />
        <circle
          cx="239.072"
          cy="12.5045"
          r="4"
          transform="rotate(87.3336 239.072 12.5045)"
          fill="white"
        />
        <circle
          cx="239.072"
          cy="12.5045"
          r="4"
          transform="rotate(87.3336 239.072 12.5045)"
          fill="white"
        />
        <circle
          cx="239.072"
          cy="12.5045"
          r="4"
          transform="rotate(87.3336 239.072 12.5045)"
          fill="white"
        />
        <circle
          cx="239.072"
          cy="12.5045"
          r="4"
          transform="rotate(87.3336 239.072 12.5045)"
          fill="white"
        />
        <circle
          cx="239.072"
          cy="12.5045"
          r="3.5"
          transform="rotate(87.3336 239.072 12.5045)"
          stroke="white"
          strokeOpacity="0.84"
        />
        <circle
          cx="255.041"
          cy="161.923"
          r="4"
          transform="rotate(87.3336 255.041 161.923)"
          fill="white"
        />
        <circle
          cx="255.041"
          cy="161.923"
          r="4"
          transform="rotate(87.3336 255.041 161.923)"
          fill="white"
        />
        <circle
          cx="255.041"
          cy="161.923"
          r="4"
          transform="rotate(87.3336 255.041 161.923)"
          fill="white"
        />
        <circle
          cx="255.041"
          cy="161.923"
          r="4"
          transform="rotate(87.3336 255.041 161.923)"
          fill="white"
        />
        <circle
          cx="255.041"
          cy="161.923"
          r="4"
          transform="rotate(87.3336 255.041 161.923)"
          fill="white"
        />
        <circle
          cx="255.041"
          cy="161.923"
          r="3.5"
          transform="rotate(87.3336 255.041 161.923)"
          stroke="white"
          strokeOpacity="0.84"
        />
      </g>
    </svg>
  );
};

export default Particles1;
